import { render, staticRenderFns } from "./ModalOrdine.vue?vue&type=template&id=561f9a00&"
import script from "./ModalOrdine.ts?vue&type=script&lang=ts&"
export * from "./ModalOrdine.ts?vue&type=script&lang=ts&"
import style0 from "./ModalOrdine.vue?vue&type=style&index=0&id=561f9a00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports